interface HideOthersBin {
  MinSize?: Maybe<number | string>;
  MaxBins?: Maybe<number | string>;
}

export const canHideOthers = (bin: Maybe<HideOthersBin>): boolean =>
  Number(bin?.MinSize) > 0 || Number(bin?.MaxBins) > 0;
